import { DEFAULT_APP_LOCATION } from './constants'

export const address = (latLng) => {
    return new Promise(function (resolve, reject) {
        const geocoder = new window.google.maps.Geocoder;
        geocoder.geocode({ location: latLng }, (results, status) => {
            if (status === 'OK' && results && results.length) {
                const formatted_address = results[0].formatted_address;
                const region = results[results.length - 2].formatted_address;
                resolve({
                    formatted_address,
                    region,
                    lat: latLng.lat,
                    lng: latLng.lng
                })
            }
        })
    });
}

export const coordinates = () => {
    return new Promise(function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(function (position) {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            resolve({ lat, lng, timestamp: new Date().getTime() });
        }, (error) => {
            resolve({ lat: DEFAULT_APP_LOCATION.lat, lng: DEFAULT_APP_LOCATION.lng, error })
        }, {
                timeout: 15000
            });
    });
}